function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M64 9.07H0l32 45.66L64 9.07z",
    style: {
      isolation: "isolate"
    },
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+CiAgPHBhdGggZD0iTTY0IDkuMDdIMGwzMiA0NS42Nkw2NCA5LjA3eiIgc3R5bGU9Imlzb2xhdGlvbjppc29sYXRlIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4=";
export { SvgArrowDown as ReactComponent };